export enum TableIdentifier {
  SHIPMENTS_TABLE = 'shipments-table',
}
